export const SPEC_ORDER = {
  reportSummary: [
    'result',
    'updatedAt',
    'createdBy',
    'revisionName',
    'fastTrackSource'
  ],
  generalInfo: [
    'manufacturer',
    'model',
    'sbios',
    'serial',
    'uuid',
    'cpu',
    'memory',
    'os',
    'screenResolution'
  ],
  graphicsInfo: [
    'vbios',
    'driver'
  ],
  notebookGraphicsInfo: [
    'vbios',
    'driver',
    'maxQTech',
  ],
  nvqualInfoHeader: [
    'coreReleaseVersion',
    'nvqualPackageVersion'
  ],
  nvqualSystemInfo: [
    'nvqualDriverVersion',
    'cudaVersion',
    'mods',
    'sbiosInfo',
    'kernel',
    'operatingSystem',
    'cpuName'
  ],
  nvqualSummaryStatus: [
    'msg'
  ],
  nvqualSummary: [
    'pass',
  ],
  nvqualReportHeader: [
    'name',
    'user',
    'created_at',
  ]
}
